import React from 'react';
import {
    Table,
    Row,
    Spin,
    Button,
    Popconfirm,
    Tabs,
    Card,
} from 'antd';

import { asyncGet, actions } from './reducers';
import { connect } from 'react-redux';
import SearchForm from './search.js';
// import Edit from './edit.js';
import { delect, delectAll } from './reducers';
const TabPane = Tabs.TabPane;

class AgencyAnalysis extends React.Component {
    constructor(props) {
        super(props);
    }
    componentDidMount() {
        this.props.asyncGet();
    }

    changeHandle = (pagination, filters, sorter) => {
        this.props.changePagination(pagination);
        this.props.asyncGet();
    };

    edit = record => {
        this.props.editShow();
        this.props.changeCurrentSelectId(record.scriptId);
    }

    handleDelete = async record => {
        record.deleteFlag = '1';
        this.props.delect(record);
        this.props.asyncGet();
    }

    renderAction = (text, record) => {
        return (
            <div>
                <Button type="primary" style={{ marginRight: '5px' }} size="small" onClick={() => { this.edit(record); }} >
                    编辑
                </Button>

                <Popconfirm title="是否删除?" onConfirm={() => { this.handleDelete(record); }} >
                    <Button type="primary" style={{ marginRight: '5px' }} size="small">
                        < a href="#">删除</a>
                    </Button>
                </Popconfirm>
            </div>
        );
    };

    onSelectChange = (selectedRowKeys, selectedRows) => {
        this.props.getTransferData({ selectedRowKeys });
    }

    render() {
        let { list, uiStatus, threadList } = this.props;
        let { isLoading } = uiStatus;

        const columns = [
            {
                title: '任务ID',
                dataIndex: 'taskId',
                key: 'taskId',
            },
            {
                title: '任务名称',
                dataIndex: 'taskDescription',
                key: 'taskDescription',
            },
            {
                title: '目标量',
                dataIndex: 'targetPv',
                key: 'targetPv',
            },
            {
                title: '位置',
                dataIndex: 'ps',
                key: 'ps',
            },
            {
                title: '广告ID',
                dataIndex: 'eId',
                key: 'eId',
            },
            {
                title: '责任人',
                dataIndex: 'principal',
                key: 'principal',
            },
            {
                title: '丢弃数量',
                dataIndex: 'dropCount',
                key: 'dropCount',
            },
        ];

        return (
            <div style={{ marginBottom: '20px' }}>
                <Row style={{ marginTop: '10px', marginTop: '10px' }}>
                    <SearchForm {...this.props} />
                </Row>
                <Spin spinning={isLoading} tip="加载中...">
                    <Tabs defaultActiveKey="1">
                        <TabPane tab="完成率丢弃" key="1">
                            <Table
                                columns={columns}
                                dataSource={list}
                                pagination={false}
                                defaultExpandAllRows={false}
                            />
                        </TabPane>
                        <TabPane tab="线程阻塞丢弃" key="2">
                            <Table
                                columns={columns}
                                dataSource={threadList}
                                pagination={false}
                                defaultExpandAllRows={false}
                            />
                        </TabPane>
                    </Tabs>
                </Spin>
            </div>
        );
    }
}

const mapStateToProps = state => ({
    selectedContent: state.discardList.selectedContent,
    list: state.discardList.list,
    pagination: state.discardList.pagination,
    proxyrepeatinfo: state.discardList.proxyrepeatinfo,
    uiStatus: state.discardList.uiStatus,
    agentsGroup: state.discardList.agentsGroup,
    transferData: state.discardList.transferData,
    threadList: state.discardList.threadList,
});
const mapDispatchToProps = dispatch => ({
    asyncGet: () => dispatch(asyncGet()),
    editShow: () => dispatch(actions.changeUiStatus({ isUpdateShow: true })),
    changeCurrentSelectId: id => dispatch(actions.changeCurrentSelectId(id)),
    delUser: id => dispatch(actions.del(id)),
    delect: record => dispatch(delect(record)),
    delectAll: selectedRowsCurr1 => dispatch(delectAll(selectedRowsCurr1)),
    getTransferData: data => dispatch(actions.getTransferData(data)),
    changePagination: data => dispatch(actions.changePagination(data)),
});
export default connect(mapStateToProps, mapDispatchToProps)(AgencyAnalysis);



// WEBPACK FOOTER //
// ./pages/monitor/discard/index.js